import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
	RoutesRecognized,
	UrlTree,
} from '@angular/router';
import { filter, Observable, pairwise } from 'rxjs';
import { AppConstants } from '../constant/app.constant';
// import { UtilityHelper } from '../helpers/utility-helper';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard implements CanActivate {
	constructor(private router: Router,
		// private utility: UtilityHelper,
	) { }

	canActivate(
		_route: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot
	):
		| Observable<boolean | UrlTree>
		| Promise<boolean | UrlTree>
		| boolean
		| UrlTree {
		let token = localStorage.getItem(AppConstants.localStorage.authToken);

	    if (token && token !== null) {
			return true;
		} else {
      this.router.navigate(['/users/account/sign-in']);
			// window.history.back();
			return false;
		}
	}
}
